import DefineTerminal from "pages/BasicInformations/define-terminal";
import QuestionBankNewUi from "pages/BasicInformations/survey/question-bank copy";
import SurveyWithNewUi2 from "pages/BasicInformations/survey/survey-refactor";
import SMSRecipientSettings from "pages/BasicInformations/sms-receipient-settings";
import PrintTemplate from "pages/BasicInformations/print-template";
import { lazy } from "react";

const Thirdparty = lazy(() => import("pages/Thirdparty/Thirdparty"));
const Transportation = lazy(
  () => import("pages/BasicInformations/Transportation")
);
const ADMVehicle = lazy(() => import("pages/ADMVehicle/ADMVehicle"));
const CustomerManagement = lazy(
  () => import("pages/CustomerManagement/CustomerManagement")
);
const ProductGroup = lazy(() => import("pages/ProductGroup/ProductGroup"));
const ServiceTime = lazy(() => import("pages/ServiceTime/ServiceTime"));
const CustomGeographic = lazy(
  () => import("pages/CustomGeographic/CustomGeographic")
);
const DefineCapacity = lazy(
  () => import("pages/BasicInformations/define-capacity")
);

export const childs: Array<ISideBarChild> = [
  // {
  //   to: "/basic-information/thirdparty",
  //   component: <Thirdparty />,
  //   code: "1007",
  //   label: "اشخاص حقیقی/حقوقی",
  //   permissions: "view_thirdparty",
  // },

  {
    to: "/basic-information/transportation",
    component: <Transportation />,
    code: "1008",
    label: "حمل و نقل",
    permissions: "view_transport",
  },
  // {
  //   to: "/basic-information/ADMVehicle",
  //   component: <ADMVehicle />,
  //   code: "1009",
  //   label: "وسایل نقلیه اجاره‌ای",
  //   permissions: "view_ADM_vehicle",
  // },
  {
    to: "/basic-information/customer-management",
    component: <CustomerManagement />,
    code: "1010",
    label: "مدیریت مشتریان",
    permissions: "view_customer_management",
  },
  // {
  //   to: "/basic-information/product-group",
  //   component: <ProductGroup />,
  //   code: "",
  //   label: "گروه بندی محصولات",
  //   permissions: "view_product_group",
  // },
  {
    to: "/basic-information/service-time",
    component: <ServiceTime />,
    code: "1012",
    label: "تعریف مدت ارائه خدمت",
    permissions: "view_time_commitment",
  },
  {
    to: "/basic-information/custom-geographic-category",
    component: <CustomGeographic />,
    code: "1013",
    label: "رده جغرافیایی سفارشی",
    permissions: "view_custom devision",
  },
  {
    to: "/basic-information/define-terminal",
    component: <DefineTerminal />,
    code: "",
    label: "تعریف ترمینال",
    permissions: "terminalDefenition",
  },
  // {
  //   to: "/basic-information/define-capacity",
  //   component: <DefineCapacity />,
  //   code: "",
  //   label: "تعیین ظرفیت احتیاطی شهر",
  //   permissions: "view_city_emergency_capacity",
  // },
  // {
  //   to: "/basic-information/survey",
  //   component: <SurveyManagement />,
  //   code: "",
  //   label: "فرم نظر سنجی",
  //   permissions: "",
  // },
  // {
  //   to: "/basic-information/question-bank",
  //   component: <QuestionBankNewUi />,
  //   code: "",
  //   label: "بانک سوالات ",
  //   permissions: "",
  // },
  {
    to: "/basic-information/survey",
    component: <SurveyWithNewUi2 />,
    // component: <SurveySection />,
    code: "",
    label: "نظرسنجی ",
    permissions: "view_survey",
  },
  // {
  //   to: "/basic-information/sms-recipient-settings",
  //   component: <SMSRecipientSettings />,
  //   code: "",
  //   label: "تنظیمات ارسال پیامک",
  //   permissions: "view_sms_sending_settings",
  // },
  {
    to: "/basic-information/print-template",
    component: <PrintTemplate />,
    code: "",
    label: "قالب پرینت",
    permissions: "view_consignment_templates",
  },
];
